<script>
	export default {
		props: {
			data: {
				type: Object,
				required: true
			},
			errorForm: {
				type: Boolean,
				required: true
			}
		},	
		watch: {
			"data.value": {
				handler(value) {
					if(value === true) this.data.error = false;
					else this.data.error = true;
				},
				deep: true,
			}
		}
	}
</script>

<template>
	<div 
		class="card bg-light" 
		:class="{ 'border-red': data.error && errorForm }"
	>
		<div class="card-body d-flex align-items-center">
			<label 
				class="w-100 form-check-label text-secondary pointer-event" 
				:for="`checkbox-${data.id}`">
				<small>
					<font-awesome-icon icon="fa-solid fa-circle-info"></font-awesome-icon>
					{{ data.label }}
				</small>
			</label>
			<input 
				class="flex-shrink-1 form-check-input input-checkbox-custom ms-2" 
				type="checkbox"
				:id="`checkbox-${data.id}`"
				v-model="data.value" 
			>
		</div>
	</div>
</template>